import React, { useState } from "react";
import DashboardLayout from "components/layouts/dashboard-layout";
import Default from "./components/default";
import PageHeader from "./components/header";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import DateConvert from "utils/dateConvert";
import BlockView from "./components/block-view";
import { RatedTubeDummyData } from "constants/dummy-data/rated-tube-dummy-data";
import ListView from "./components/list-view";
import PageLinks from "components/page-links";

export interface IFilter {
  filter: [
    { section: "Date"; filter: { to: Date | null; from: Date | null } },
    { section: "Artist"; filter: string },
    { section: "Status"; filter: string },
    { section: "Type"; filter: string }
  ];
}
const RatedTube = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [viewType, setViewType] = useState("list");
  const [searchInput, setSearchInput] = useState("");
  const [searchFilter, setSearchFilter] = useState<IFilter>({
    filter: [
      { section: "Date", filter: { to: null, from: null } },
      { section: "Artist", filter: "" },
      { section: "Status", filter: "" },
      { section: "Type", filter: "" }
    ]
  });
  const resetFilterItem = (sectionToReset: string) => {
    setSearchFilter({
      filter: [
        sectionToReset === "Date"
          ? { section: "Date", filter: { from: null, to: null } }
          : searchFilter.filter[0], // Date filter

        sectionToReset === "Artist"
          ? { section: "Artist", filter: "" }
          : searchFilter.filter[1], // Artist filter

        sectionToReset === "Status"
          ? { section: "Status", filter: "" }
          : searchFilter.filter[2], // Status filter

        sectionToReset === "Type"
          ? { section: "Type", filter: "" }
          : searchFilter.filter[3] // Type filter
      ] as [
        { section: "Date"; filter: { from: Date | null; to: Date | null } },
        { section: "Artist"; filter: string },
        { section: "Status"; filter: string },
        { section: "Type"; filter: string }
      ]
    });
  };
  return (
    <DashboardLayout>
      <>
        <PageLinks
          from={{ name: "Overview", link: "/overview" }}
          current="Rated-Tube"
        />
        {!subscribed && <Default />}
        {subscribed && (
          <>
            <PageHeader
              onChangeView={(viewType) => setViewType(viewType)}
              onChangeSearch={(value) => setSearchInput(value)}
              filter={searchFilter}
              setFilter={(value) => setSearchFilter(value)}
            />
            {searchFilter.filter.length > 0 && (
              <Filters>
                {searchFilter.filter.map(({ section, filter }, i) => {
                  const to = searchFilter.filter[0].filter.to;
                  const from = searchFilter.filter[0].filter.from;

                  if (filter === "") {
                    return null; // Skip empty filter items.
                  }

                  if (i === 0) {
                    if (to === null || from === null) {
                      return null; // Skip empty date filter.
                    }
                    return (
                      <FilterItem key={i}>
                        <Typography color={Colors.grey400} size="s">
                          {section}:
                        </Typography>
                        <Typography
                          color={Colors.grey400}
                          size="s"
                          ml="0.4"
                          weight="semibold"
                        >
                          {DateConvert(from)} - {DateConvert(to)}
                        </Typography>
                        <CloseIcon
                          onClick={() => {
                            setSearchFilter({
                              filter: [
                                {
                                  section: "Date",
                                  filter: { to: null, from: null }
                                },
                                searchFilter.filter[1],
                                searchFilter.filter[2],
                                searchFilter.filter[3]
                              ]
                            });
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M9 3L3 9.00001M3 3L9 9.00001"
                              stroke="#CDCDCD"
                              stroke-width="0.642857"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </CloseIcon>
                      </FilterItem>
                    );
                  }

                  return (
                    <FilterItem
                      key={i}
                      onClick={() => resetFilterItem(section)}
                    >
                      <Typography color={Colors.grey400} size="s">
                        {section}:
                      </Typography>
                      <Typography
                        color={Colors.grey400}
                        size="s"
                        ml="0.4"
                        weight="semibold"
                      >
                        {filter}
                      </Typography>
                      <CloseIcon>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M9 3L3 9.00001M3 3L9 9.00001"
                            stroke="#CDCDCD"
                            stroke-width="0.642857"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </CloseIcon>
                    </FilterItem>
                  );
                })}
              </Filters>
            )}
          </>
        )}
        {subscribed && viewType === "block" && (
          <BlockView data={RatedTubeDummyData} />
        )}
        {subscribed && viewType === "list" && (
          <ListView data={RatedTubeDummyData} />
        )}
      </>
    </DashboardLayout>
  );
};

export default RatedTube;

const Filters = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  margin-bottom: 2rem;
`;

const FilterItem = styled.div`
  border-radius: 0.4rem;

  background: ${Colors.grey600};
  padding: 0.4rem 0.8rem;
  margin-left: 0.8rem;
  margin-top: 1.2rem;
  display: flex;
`;

const CloseIcon = styled.div`
  width: 1.2rem;
  cursor: pointer;
  margin-left: 0.4rem;
`;
